import { html, property } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './option.lit.scss';

/**
 * @component {kat-option} KatalOption An option that can be selected inside a <kat-dropdown>.
 * @status Production
 * @theme flo
 * @contentProvided
 * @slot default The inner HTML of the option in the option list of the dropdown.
 */
@register('kat-option')
export class KatalOption extends KatLitElement {
  /**
   * @classprop {string} value The value of the option. Will be the value of the dropdown when this option is selected.
   */
  @property({ type: String, reflect: true })
  value: string;

  /**
   * Whether the option is selected or not.
   */
  @property({ type: Boolean, reflect: true })
  selected: boolean;

  /**
   * @classprop {boolean} disabled A disabled option displays in dimmed text and can't be selected.
   */
  @property({ type: Boolean, reflect: true })
  disabled: boolean;

  static get styles() {
    return [baseStyles, styles];
  }

  firstUpdated() {
    this.setAttribute('tabindex', '-1');
  }

  render() {
    return html`
      <div class="content">
        <slot></slot>
      </div>
      <span class="ring"></span>
    `;
  }
}
